<script lang="ts">
    import { idPageHome } from "../scripts/router2";
    import PodcastCategories from '../components/PodcastCategories.svelte';
    import { tick } from 'svelte';
    import { scrollTopMainRoute } from '../scripts/common';

    tick().then(() => {
        scrollTopMainRoute();
    })

    
</script>
    
<style lang="scss">

    .home {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 100%;
        &__podcasts {
            margin: 0 0 100px 0;
            width: 100%;
            height: 100%;
        }
    }

    @include large {
        .home {
            &__podcasts {
                margin: 10px 0 100px 0;
            }
        }
    }

</style>

<div id={idPageHome} class="page">
    <div class="home">
        <div class="home__podcasts">
            <PodcastCategories />
        </div>    
    </div>
</div>
